import { useEffect } from "react";
import { getSocket } from "../api/rooms";

// Eagerly opens the user socket on app mount so `presence:lobby`
// tracks every logged-in player — including those parked on pages
// that don't otherwise need a channel (collection, deck builder,
// admin). Failure is silent: callers like LobbyPage / BattlePage
// will reopen the socket on demand. On /login the underlying
// `/api/me` call 401s, which is also fine.
export function usePresenceConnect(): void {
  useEffect(() => {
    void getSocket().catch(() => {});
  }, []);
}
